import { render, staticRenderFns } from "./RePhone.vue?vue&type=template&id=77371f2b&scoped=true&"
import script from "./RePhone.vue?vue&type=script&lang=js&"
export * from "./RePhone.vue?vue&type=script&lang=js&"
import style0 from "./RePhone.vue?vue&type=style&index=0&id=77371f2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77371f2b",
  null
  
)

export default component.exports